function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_755",
  "data-name": "Group 755",
  transform: "translate(12500 5797)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_326",
  "data-name": "Rectangle 326",
  transform: "translate(-12500 -5797)",
  fill: "#fff",
  stroke: "#707070",
  strokeWidth: 2,
  opacity: 0.56
}, /*#__PURE__*/React.createElement("rect", {
  width: 25,
  height: 22,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 23,
  height: 20,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_324",
  "data-name": "Rectangle 324",
  transform: "translate(-12432 -5792)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 2,
  opacity: 0.56
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 19,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 18,
  height: 17,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_322",
  "data-name": "Rectangle 322",
  transform: "translate(-12340 -5796)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 2,
  opacity: 0.56
}, /*#__PURE__*/React.createElement("rect", {
  width: 19,
  height: 19,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 17,
  height: 17,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path_106",
  "data-name": "Path 106",
  transform: "translate(-12266 -5796)",
  fill: "none",
  opacity: 0.56
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0H15V15H0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 2 2 L 2 13 L 13 13 L 13 2 L 2 2 M 0 0 L 15 0 L 15 15 L 0 15 L 0 0 Z",
  stroke: "none",
  fill: "#707070"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_328",
  "data-name": "Rectangle 328",
  transform: "translate(-12219 -5786)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 2,
  opacity: 0.56
}, /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 13,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 10,
  height: 11,
  fill: "none"
})));

var SvgRecGroupR = function SvgRecGroupR(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 24,
    viewBox: "0 0 293 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRecGroupR, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/REC_Group_R.3728cf98.svg";
export { ForwardRef as ReactComponent };